import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";
import { INDUSTRIES } from "@/lib/data";

export default function Industries() {
  return (
    <section
      data-testid={HOME_SECTIONS.industries}
      className="relative bg-ink-900 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <SectionLabel number="09">Industry Experience</SectionLabel>
            <h2 className="mt-6 font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
              Across categories.<br />
              <span className="italic text-gold">Deliberately.</span>
            </h2>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-x-6 gap-y-1 md:grid-cols-3">
              {INDUSTRIES.map((ind, i) => (
                <motion.div
                  key={ind.slug}
                  initial={{ opacity: 0, y: 12 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.5, delay: i * 0.03 }}
                >
                  <Link
                    to={`/industries/${ind.slug}`}
                    className="group block border-b border-ivory/[0.06] py-4"
                  >
                    <div className="flex items-center justify-between gap-4">
                      <span className="font-display text-2xl tracking-tight text-ivory transition-colors group-hover:text-gold">
                        {ind.name}
                      </span>
                      <span className="font-sans text-xs uppercase tracking-widest text-ivory-dim">
                        →
                      </span>
                    </div>
                    <div className="mt-1 font-sans text-[11px] uppercase tracking-widest text-ivory-muted">
                      {ind.tag}
                    </div>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
